module.exports = __webpack_public_path__ + "img/delete-icon.20653219.svg";